export default __webpack_public_path__ + "static/media/mastercard.77f05aa2.svg";